import axios from "axios";
import React, { useState, useContext } from "react";
import { url } from "../utils/url";
import { Link } from "react-router-dom";
import Logged from "../Components/Profile.jsx";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import UpdateAvatarModal from "./Modals/UpdateAvatarModal";
import { LoadingOutlined } from "@ant-design/icons";
import SidebarNav from "./navigation/SidebarNav";
const EditProfile = () => {
  const { user, updateDetails } = useContext(UserContext);
  const [username, setusername] = useState();
  const [names, setnames] = useState();
  // const [email, setemail] = useState();
  const [avatar, setavatar] = useState();
  const [img, setimg] = useState();
  const [userStatus, setuserStatus] = useState();
  const [modalShow, setmodalShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleusername = (e) => {
    setusername(e.target.value);
  };
  const handlenames = (e) => {
    setnames(e.target.value);
  };
  // const handleemail = (e) => {
  //   setemail(e.target.value);
  // };

  const handleavatar = (newAvatar, newImage) => {
    setavatar(newAvatar);
    setimg(newImage);
  };
  console.log("form ", img);
  const handleuserStatus = (e) => {
    setuserStatus(e.target.value);
  };
  let img_url;
  if (avatar) {
    img_url = avatar?.includes("/avatars") ? url + avatar : avatar;
  }
  // console.log(img_url)
  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", img);
    setLoading(true);

    // let alternativeFileSubmission = img?formData
    if (img) {
      // checking if user uploaded image
      await axios
        .post(
          `${url}/api/posts/upload-image/${user.info?._id}?action=user`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        )
        .then((res) => {
          window.Toast.fire({
            icon: "success",
            title: "Account details updated",
          });
          updateDetails(res.data?.data);
        })
        .catch((err) => {
          window.displayToastError("Operation failed.");
          setLoading(false);
        });
    } else {
      if (avatar) {
        // checking if the user picked img from avatars
        await axios
          .put(
            `${url}/api/auth/update/${user.info?._id}`,
            {
              username,
              names,
              // email,
              userStatus,
              profile: {
                url: avatar || user.info?.profile?.url,
                provider: "local",
              },
            },
            {
              headers: {
                Authorization: `Bearer ${user.token}`,
              },
            }
          )
          .then((res) => {
            window.Toast.fire({
              icon: "success",
              title: "Account details updated",
            });
            updateDetails(res.data?.data);
          })
          .catch((err) => {
            window.displayToastError("Operation failed.");
            setLoading(false);
          });
      } else {
        // checking if the user didn't do anything with the images
        await axios
          .put(
            `${url}/api/auth/update/${user.info?._id}`,
            {
              username,
              names,
              // email,
              userStatus,
            },
            {
              headers: {
                Authorization: `Bearer ${user.token}`,
              },
            }
          )
          .then((res) => {
            window.Toast.fire({
              icon: "success",
              title: "Account details updated",
            });
            updateDetails(res.data?.data);
          })
          .catch((err) => {
            window.displayToastError("Operation failed.");
            setLoading(false);
          });
      }
    }
    setLoading(false);
  }

  return (
   
    <div className="flex justify-center w-full">
        <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
          <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
                <SidebarNav />
              </div>
            </div>
            <div className="col-span-6">
              <form className="w-full " onSubmit={handleSubmit}>
                <h1 className="text-sm font-bold mt-5 mb-3"> Edit profile</h1>
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label htmlFor="usernameup">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={user.info?.username}
                      value={username}
                      onChange={handleusername}
                      id="usernameup"
                      placeholder=""
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="namesupdate">Names</label>
                    <input
                      type="text"
                      className="form-control"
                      id="namesupdate"
                      defaultValue={user.info?.names}
                      value={names}
                      onChange={handlenames}
                      placeholder=""
                    />
                  </div>
                </div>
                {/* cant' update the email right now */}

                {/* <div className="form-group">
                <label htmlFor="emailupdate">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="emailupdate"
                  defaultValue={user.info?.email}
                  value={email}
                  onChange={handleemail}
                  placeholder=""
                />
              </div> */}
                <div className="form-group">
                  <label htmlFor="statusupdate">Status</label>
                  <input
                    type="text"
                    className="form-control"
                    id="statusupdate"
                    defaultValue={user.info?.userStatus}
                    value={userStatus}
                    onChange={handleuserStatus}
                    placeholder=""
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="avatarupdate" className="d-block">
                    Avatar
                  </label>
                  <div className="flex items-center justify-center">
                    <div className="flex ">
                      <img
                        alt="Avatar"
                        src={
                          avatar
                            ? `${img_url}`
                            : `${
                                user.info?.image
                                  ? user.info?.image
                                  : url + user.info?.profile?.url
                              }`
                        }
                        className="rounded-full object-cover cursor-pointer w-36 h-36
                  
                  hover:shadow-lg
                  hover:opacity-50
                  "
                        onClick={() => {
                          setmodalShow(true);
                        }}
                      />
                      <div className="flex items-end">
                        <button
                          type="button"
                          className=" rounded-full p-2 bg-fire my-3 hover:opacity-50
                  focus:outline-none
                  "
                          onClick={() => {
                            setmodalShow(true);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path
                              d="M12.9 6.858l4.242 4.243L7.242 21H3v-4.243l9.9-9.9zm1.414-1.414l2.121-2.122a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414l-2.122 2.121-4.242-4.242z"
                              fill="rgba(255,255,255,1)"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <UpdateAvatarModal
                    show={modalShow}
                    onHide={() => {
                      setmodalShow(false);
                    }}
                    handleavatar={handleavatar}
                    currentAvatar={
                      avatar
                        ? avatar
                        : user.info?.image
                        ? user.info?.image
                        : user.info?.profile?.url
                    }
                  ></UpdateAvatarModal>
                </div>
                {!loading ? (
                  <button
                    type="submit"
                    className="btn bg-fire upda-btn text-white"
                  >
                    Update
                  </button>
                ) : (
                  <button
                    className="btn bg-fire upda-btn opacity-50 text-white flex gap-4 items-center"
                    disabled
                  >
                    <LoadingOutlined />
                    <span> Updating ...</span>
                  </button>
                )}
                <span className="float-right update-pass">
                  <Link to="/change-password">Change password?</Link>{" "}
                </span>
              </form>
            </div>
          </div>
          <div className="lg:col-span-5">
            {user.token ? <Logged /> : <TryLogin />}
          </div>
        </div>
      </div>
    
  );
};
export default EditProfile;
